import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import dayjs from 'dayjs';
import { capitalize } from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';

import { OpenClass } from '../types/OpenClass';
import { openClassesOnDate } from '../utils/openClassCalendar';
import OpenClassCatalog from './OpenClassCatalog';

type DateOpenClassesModalProps = {
  date: dayjs.Dayjs;
  loading: boolean;
  openClasses: OpenClass[];
  refreshOpenClasses: () => Promise<void>;
  onCancel: () => void;
};

const DateOpenClassesModal: React.FC<DateOpenClassesModalProps> = ({
  date,
  loading,
  openClasses,
  refreshOpenClasses,
  onCancel,
}) => {
  const [searchDate, setSearchDate] = useState<dayjs.Dayjs>(date);

  const openClassesForDay = useMemo(
    () => openClassesOnDate(openClasses, searchDate.format('YYYY-MM-DD')),
    [openClasses, searchDate],
  );

  const prev = useCallback(
    () => setSearchDate((current) => current.subtract(1, 'day')),
    [],
  );

  const next = useCallback(
    () => setSearchDate((current) => current.add(1, 'day')),
    [],
  );

  const modalTitle = (
    <div className="flex flex-col sticky">
      <div style={{ width: '15rem' }}>
        <span className="font-semibold text-lg">
          {`${capitalize(searchDate.format('dddd'))} ${searchDate.format(
            'D MMMM',
          )}`}
        </span>
        <span className="text-gray-600 text-sm">
          {' '}
          - {searchDate.format('YYYY')}
        </span>
      </div>
      <div className="flex flex-row mt-1 -mb-1">
        <Button onClick={prev} className="mr-2">
          <LeftOutlined />
        </Button>
        <Button onClick={next}>
          <RightOutlined />
        </Button>
      </div>
    </div>
  );

  return (
    <Modal
      title={modalTitle}
      className="w-11/12"
      open
      footer={null}
      onCancel={onCancel}
      bodyStyle={{ overflowX: 'scroll' }}
      maskClosable={false}>
      <div style={{ overflow: 'auto', height: '60vh' }}>
        <OpenClassCatalog
          loading={loading}
          openClasses={openClassesForDay}
          refreshOpenClasses={refreshOpenClasses}
        />
      </div>
    </Modal>
  );
};

export default DateOpenClassesModal;
